/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Icon/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import CheckedOut from './CheckedOut/index'
import No from './No/index'
import React from 'react'
import Scheduled from './Scheduled/index'
import Seated from './Seated/index'
import Unplanned from './Unplanned/index'



/** @type {import('Simple/types.js').View} */
export default function Icon({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Indicator/Past/Icon"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let eventAppointmentValueData = fromData.useDataFormat({ viewPath,
context: 'event',
path: 'appointment',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: eventAppointmentValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Unplanned'}>
<Unplanned
  viewPath={`${viewPath}/Unplanned`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Scheduled'}>
<Scheduled
  viewPath={`${viewPath}/Scheduled`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Seated'}>
<Seated
  viewPath={`${viewPath}/Seated`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CheckedOut'}>
<CheckedOut
  viewPath={`${viewPath}/CheckedOut`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}